import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import EventBus from '../../scripts/lib/EventBus.js';
import type { EntsDrawer } from '../drawer/drawer.js';

const templateElement = document.getElementById('certificate-template');
export default defineComponent({
  template: templateElement ? templateElement.innerHTML : '',

  setup() {
    const drawer = ref<EntsDrawer | null>(null);
    const certifiedColumn = ref<unknown[]>([]);

    onMounted(() => {
      EventBus.on('ents:vue:certificate:drawer:open', (column: unknown[]) => {
        certifiedColumn.value = column;
        openCertificateDrawer();
      });
    });

    onUnmounted(() => {
      EventBus.off('ents:vue:certificate:drawer:open', openCertificateDrawer);
    });

    const openCertificateDrawer = async () => {
      await import('../drawer/drawer.js');
      const drawerElement = drawer.value as EntsDrawer;
      await drawerElement.updateComplete;
      drawerElement.show();
    };

    return {
      drawer,
      certifiedColumn,
    };
  },
});
